import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { useGetDataProperty } from 'automation-ui-formula-editor/data-sources/hooks/useGetDataProperty';
import getTokenParts from 'automation-ui-formula-editor/data-sources/utils/getTokenParts';
import MissingLabel from 'automation-ui-core/components/MissingLabel';
import PropertyName from 'automation-ui-references/object-type-properties/PropertyName';
import DataSourceName from 'automation-ui-formula-editor/data-sources/DataSourceName';
import SkeletonText from 'automation-ui-core/components/SkeletonText';
import { jsx as _jsx } from "react/jsx-runtime";
export default function StaticBranchActionDetailFromDataToken({
  langKey,
  token
}) {
  var _data$dataSourceDefin;
  const {
    prefix,
    property
  } = getTokenParts(token);
  const {
    data,
    error,
    loading
  } = useGetDataProperty({
    prefix,
    property
  });
  const metadata = (_data$dataSourceDefin = data === null || data === void 0 ? void 0 : data.dataSourceDefinition.metadata) !== null && _data$dataSourceDefin !== void 0 ? _data$dataSourceDefin : null;
  let propertyTypeId = null;
  let sourcePropertyName;
  if (metadata) {
    if ('eventTypeId' in metadata) {
      var _data$dataSourcePrope;
      propertyTypeId = metadata.eventTypeId;
      // could replace all property names with this but I don't want to mess with it
      sourcePropertyName = data === null || data === void 0 || (_data$dataSourcePrope = data.dataSourceProperty) === null || _data$dataSourcePrope === void 0 ? void 0 : _data$dataSourcePrope.label;
    } else if ('associationDefinition' in metadata) {
      propertyTypeId = metadata.associationDefinition.toObjectTypeId;
      sourcePropertyName = /*#__PURE__*/_jsx(PropertyName, {
        propertyName: property,
        objectTypeId: propertyTypeId
      });
    } else if ('objectTypeId' in metadata) {
      propertyTypeId = metadata.objectTypeId;
      sourcePropertyName = /*#__PURE__*/_jsx(PropertyName, {
        propertyName: property,
        objectTypeId: propertyTypeId
      });
    }
  } else {
    var _data$dataSourcePrope2;
    sourcePropertyName = data === null || data === void 0 || (_data$dataSourcePrope2 = data.dataSourceProperty) === null || _data$dataSourcePrope2 === void 0 ? void 0 : _data$dataSourcePrope2.label;
  }
  return /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: langKey,
    options: {
      sourcePropertyName: loading ? /*#__PURE__*/_jsx(SkeletonText, {}) : error ? /*#__PURE__*/_jsx(MissingLabel, {
        type: "property"
      }) : sourcePropertyName,
      dataSourceName: loading ? /*#__PURE__*/_jsx(SkeletonText, {}) : error ? /*#__PURE__*/_jsx(MissingLabel, {
        type: "object"
      }) : /*#__PURE__*/_jsx("strong", {
        children: /*#__PURE__*/_jsx(DataSourceName, {
          dataSourcePrefix: prefix
        })
      })
    }
  });
}